export const JOB_REQUEST = 'JOB_REQUEST'
export const JOB_SUCCESS = 'JOB_SUCCESS'
export const JOB_FAILURE = 'JOB_FAILURE'
export const JOB_CHANGE = 'JOB_CHANGE'
